import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import PageHero from "@/components/PageHero";
import { IMG, SERVICES } from "@/lib/siteData";
import { useLang } from "@/context/LangContext";

export default function ServicesPage() {
    const { t } = useLang();
    return (
        <>
            <PageHero testid="services-hero" eyebrow={t("Nos services", "Our services")} img={IMG.sea}
                title={t("Des solutions de transport complètes et sur mesure", "Complete, tailor-made transport solutions")}
                text={t("Route, mer, air ou multimodal : nous organisons chaque expédition selon votre marchandise, votre délai et votre budget.", "Road, sea, air or multimodal: we organise each shipment according to your goods, deadline and budget.")} />
            <section className="max-w-7xl mx-auto px-5 lg:px-8 py-16 space-y-6">
                {SERVICES.map((s) => (
                    <article id={s.slug} key={s.slug} data-testid={`services-item-${s.slug}`} className="scroll-mt-24 grid md:grid-cols-[220px_1fr] gap-6 border border-slate-200 rounded-md p-6 hover:shadow-lg transition-shadow">
                        {s.img ? <img src={s.img} alt={t(s.title, s.titleEn)} className="w-full h-36 object-cover rounded" /> : (
                            <div className="h-36 rounded bg-orange-50 flex items-center justify-center"><s.icon size={48} className="text-[#f26b1d]" strokeWidth={1.3} /></div>
                        )}
                        <div>
                            <div className="flex items-center gap-3"><s.icon size={24} className="text-[#f26b1d]" /><h2 className="font-display text-2xl font-bold">{t(s.title, s.titleEn)}</h2></div>
                            <p className="text-slate-700 mt-3">{t(s.desc, s.descEn)}</p>
                            <p className="text-sm text-slate-600 mt-2 leading-relaxed">{t(s.long, s.longEn)}</p>
                            <Link to="/devis" className="text-sm text-[#f26b1d] font-medium mt-4 inline-flex items-center gap-2">{t("Demander un devis", "Request a quote")} <ArrowRight size={14} /></Link>
                        </div>
                    </article>
                ))}
            </section>
        </>
    );
}
